import { FC, useEffect } from "react";
import {
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Connection, UsernamePasswordClientFormValues } from "types";
import { Controller, useForm } from "react-hook-form";

type Props = {
  onChange: (values: UsernamePasswordClientFormValues) => void;
  initialData?: Connection;
};

const SDFConnection: FC<Props> = ({ initialData, onChange }) => {
  const { t } = useTranslation();

  const {
    control,
    watch,
    formState: { errors, isValid },
  } = useForm<UsernamePasswordClientFormValues>({
    defaultValues: {
      username: initialData?.metadata?.username || "",
      password: "",
      client: initialData?.metadata?.client || "",
    },
    mode: "onChange", // Validate on each change
  });

  const formValues = watch();

  // Pass form values and validity to parent
  useEffect(() => {
    onChange({
      ...formValues,
      isValid: Boolean(formValues.username && formValues.password) // Simple validation
    });
  }, [formValues, onChange]);

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">
        {t("connection:connection_details")}
      </Typography>

      <Controller
        name="username"
        control={control}
        rules={{
          required: t("alert:missing_value"),
        }}
        render={({ field }) => (
          <TextField
            {...field}
            label={t("connection:username")}
            variant="outlined"
            fullWidth
            error={!!errors.username}
            helperText={errors.username ? errors.username.message : ""}
            disabled={!!initialData}
          />
        )}
      />
      
      {!initialData && (
        <Controller
          name="password"
          control={control}
          rules={{
            required: t("alert:missing_value"),
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label={t("connection:password")}
              variant="outlined"
              fullWidth
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ""}
              type={"password"}
            />
          )}
        />
      )}

      <Controller
        name="client"
        control={control}
        rules={{
          required: t("alert:missing_value"),
        }}
        render={({ field }) => (
          <TextField
            {...field}
            label={t("connection:client")}
            variant="outlined"
            fullWidth
            error={!!errors.client}
            helperText={errors.client ? errors.client.message : ""}
            disabled={!!initialData}
          />
        )}
      />
      
    </Stack>
  );
};

export default SDFConnection;
